import { decimalToPercent, percentToDecimal } from './percentUtils';

/**
 * Converts opacity to transparency.
 * Example: 0.3 (input) -> 0.7 (output)
 */
export function opacityToTransparency(opacity: number): number {
    return 1 - opacity;
}

// convert opacity (decimal) to transparency (%)
export function convertOpacity(opacity: number) {
    const transparency = opacityToTransparency(opacity);
    const percent = decimalToPercent(transparency);
    return percent;
}

/**
 * Converts transparency to opacity.
 * Example: 0.7 (input) -> 0.3 (output)
 */
export function transparencyToOpacity(transparency: number): number {
    return 1 - transparency;
}

/**
 * Converts transparency percent to opacity.
 * Example: 70 (input) -> 0.3 (output)
 */
export function transparencyPercentToOpacity(transparencyPercent: number): number {
    const transparencyDecimal = percentToDecimal(transparencyPercent);
    return transparencyToOpacity(transparencyDecimal);
}
